
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xml:space": "preserve",
    "width": "200%",
    "height": "200%",
    "version": "1.1",
    "style": "shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd",
    "viewBox": "0 0 6000 4000",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "radialGradient",
          "attrsMap": {
            "id": "id0",
            "gradientUnits": "userSpaceOnUse",
            "gradientTransform": "matrix(-0.0151269 -2.42013 2.42015 -0.0151269 -6454 6256)",
            "cx": "1246.94",
            "cy": "3189.84",
            "r": "854.12",
            "fx": "1246.94",
            "fy": "3189.84"
          },
          "children": [
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "0",
                "style": "stop-opacity:1; stop-color:#48A5EA"
              }
            },
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "0.619608",
                "style": "stop-opacity:1; stop-color:#2F85E8"
              }
            },
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "1",
                "style": "stop-opacity:1; stop-color:#1766E7"
              }
            }
          ]
        },
        {
          "tag": "radialGradient",
          "attrsMap": {
            "id": "id1",
            "gradientUnits": "userSpaceOnUse",
            "gradientTransform": "matrix(-0.0100122 -3.0853 3.08525 -0.0100121 -7646 16788)",
            "cx": "4181.82",
            "cy": "3847.26",
            "r": "811.02",
            "fx": "4181.82",
            "fy": "3847.26"
          },
          "children": [
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "0",
                "style": "stop-opacity:1; stop-color:#429DEA"
              }
            },
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "0.678431",
                "style": "stop-opacity:1; stop-color:#2F85E8"
              }
            },
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "1",
                "style": "stop-opacity:1; stop-color:#1D6EE7"
              }
            }
          ]
        },
        {
          "tag": "radialGradient",
          "attrsMap": {
            "id": "id2",
            "gradientUnits": "userSpaceOnUse",
            "gradientTransform": "matrix(-0.013363 -3.03938 3.03933 -0.0133627 -3977 20420)",
            "cx": "5653.6",
            "cy": "3193.66",
            "r": "607.66",
            "fx": "5653.6",
            "fy": "3193.66"
          },
          "children": [
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "0",
                "style": "stop-opacity:1; stop-color:#3E98EA"
              }
            },
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "0.741176",
                "style": "stop-opacity:1; stop-color:#2E83E8"
              }
            },
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "1",
                "style": "stop-opacity:1; stop-color:#1E6FE7"
              }
            }
          ]
        },
        {
          "tag": "radialGradient",
          "attrsMap": {
            "id": "id3",
            "gradientUnits": "userSpaceOnUse",
            "gradientTransform": "matrix(-0.0118569 -3.08526 3.08526 -0.0118568 -6640 12043)",
            "cx": "2887.14",
            "cy": "3098.9",
            "r": "588.7",
            "fx": "2887.14",
            "fy": "3098.9"
          },
          "children": [
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "0",
                "style": "stop-opacity:1; stop-color:#3E98E9"
              }
            },
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "0.670588",
                "style": "stop-opacity:1; stop-color:#2C81E8"
              }
            },
            {
              "tag": "stop",
              "attrsMap": {
                "offset": "1",
                "style": "stop-opacity:1; stop-color:#1B6BE7"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "图层_x0020_1"
      },
      "children": [
        {
          "tag": "metadata",
          "attrsMap": {
            "id": "CorelCorpID_0Corel-Layer"
          }
        },
        {
          "tag": "g",
          "attrsMap": {
            "id": "_2236641117632"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "polygon",
                  "attrsMap": {
                    "class": "fil0",
                    "points": "-2182.26,2183.2 -1487.72,1491.98 -1057.76,1905.38 -1061.08,1984.76 -1114,1974.84 -1481.1,1607.74 -2056.58,2183.2 -1500.94,2768.6 -1107.38,2404.8 -1064.38,2408.1 -1064.38,2494.08 -1474.48,2877.74 "
                  }
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "class": "fil0",
                        "d": "M-1114.54 1974.5l3.32 99.22 -47.96 52.92c0,0 -147.18,-157.1 -266.24,-162.06 -119.06,-4.96 -115.76,3.3 -115.76,3.3 0,0 -165.34,67.8 -163.7,234.82 1.64,167.02 147.16,219.92 219.92,218.28 72.76,-1.64 200.08,-57.86 266.24,-112.44 66.16,-54.58 79.38,-71.12 105.84,13.22 26.46,84.34 -3.66,90.68 -3.66,90.68l51.62 -4.68 0 -178.6 -26.46 -33.06 24.8 -44.66 -160.4 19.84c0,0 -148.82,-125.68 -233.16,-124.02 -84.34,1.66 -168.68,67.8 -153.8,162.06 14.88,94.26 97.58,132.32 148.84,127.34 51.26,-4.98 155.44,-52.94 196.78,-109.16 41.34,-56.22 41.34,-56.22 41.34,-56.22l160.4 -19.84 4.96 -167.02 -52.92 -9.92z"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "class": "fil0",
                        "d": "M-1016.72 2409.5l-3.32 -99.22 47.96 -52.92c0,0 147.18,157.1 266.24,162.06 119.06,4.96 115.76,-3.3 115.76,-3.3 0,0 165.34,-67.8 163.7,-234.82 -1.64,-167.02 -147.16,-219.92 -219.92,-218.28 -72.76,1.64 -200.08,57.86 -266.24,112.44 -66.16,54.58 -79.38,71.12 -105.84,-13.22 -26.46,-84.34 3.66,-90.68 3.66,-90.68l-51.62 4.68 0 178.6 26.46 33.06 -24.8 44.66 160.4 -19.84c0,0 148.82,125.68 233.16,124.02 84.34,-1.66 168.68,-67.8 153.8,-162.06 -14.88,-94.26 -97.58,-132.32 -148.84,-127.34 -51.26,4.98 -155.44,52.94 -196.78,109.16 -41.34,56.22 -41.34,56.22 -41.34,56.22l-160.4 19.84 -4.96 167.02 52.92 9.92z"
                      }
                    }
                  ]
                },
                {
                  "tag": "polygon",
                  "attrsMap": {
                    "class": "fil0",
                    "points": "-1062.78,1984.76 -1059.46,1905.38 -655.1,1495.22 46.06,2176.54 -643.52,2882.64 -1066.08,2494.08 -1066.08,2400.8 -1018.22,2399.18 -648.48,2770.2 -68.04,2188.1 -640.2,1617.6 -1015.88,1971.9 -1015.96,2073.6 -1065.26,2068.26 "
                  }
                }
              ]
            },
            {
              "tag": "path",
              "attrsMap": {
                "class": "fil1",
                "d": "M341.6 2565.08l0 -1177.4 1435.38 0c0,0 264.58,92.6 264.58,370.42 0,277.82 8.26,808.66 8.26,808.66l-329.08 3.3 5.02 -757.44c0,0 -3.34,-178.6 -191.84,-178.6 -188.5,0 -195.12,3.3 -195.12,3.3l3.3 929.36 -320.8 0 0 -939.28 -353.88 0 0 945.9 -322.5 0 -3.32 -8.22z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "class": "fil2",
                "d": "M3325.72 1391.7l-558.94 0c0,0 -482.86,19.82 -472.94,568.84 9.92,549.02 472.94,608.54 472.94,608.54l565.54 0 0 -241.42 -499.4 0c0,0 -148.84,-43.02 -188.52,-158.76 -39.68,-115.74 9.12,-58.7 44.66,-68.62 35.54,-9.92 645.76,0 645.76,0l0 -243.96 -691.24 0c0,0 -28.14,-216.6 158.74,-219.92 186.88,-3.32 529.18,0 529.18,0l-5.78 -244.7z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "class": "fil3",
                "d": "M3998 1381.76l754.08 0 0 254.66 -334.04 -3.32 -314.2 0c0,0 -238.12,0.02 -234.82,294.36 3.3,294.34 132.3,396.88 251.36,396.88 119.06,0 297.66,0 297.66,0l6.86 -691.16 327.18 0 0 1008.66c0,0 -23.16,357.16 -377.04,360.48 -353.88,3.32 -730.92,0 -730.92,0l0 -244.74 678 0c0,0 99.22,-42.96 102.54,-100.84 3.32,-57.88 0,-87.64 0,-87.64l-438.22 0c0,0 -413.44,-74.44 -443.2,-461.4 -29.76,-386.96 85.98,-615.16 454.76,-725.94z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "class": "fil4",
                "d": "M5105.44 1373.86l757.38 0c0,0 357.2,138.9 360.5,426.64 3.3,287.74 0,770.6 0,770.6l-892.98 0c0,0 -324.1,-46.3 -320.8,-317.5 3.3,-271.2 178.58,-390.26 287.72,-390.26 109.14,0 608.54,0 608.54,0l0 238.12 0 213.34 -436.56 0c0,0 -133.92,-8.26 -132.28,-104.18 1.64,-95.92 104.16,-109.14 122.36,-109.14 18.2,0 446.48,0 446.48,0l0 -238.14c0,0 23.38,-228.22 -163.48,-229.86 -186.86,-1.64 -638.32,0 -638.32,0l1.44 -259.62z"
              }
            },
            {
              "tag": "rect",
              "attrsMap": {
                "class": "fil5",
                "x": "4424.56",
                "y": "1621.39",
                "width": "327.52",
                "height": "45.46"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  